import InfoPanel from 'core-uda/ui/InfoPanel'
import { APP } from 'core-uda/model/Resource'
import CpcFromInfoPanelTplStache from 'thm/ui/common/cpcFrom/CpcFromInfoPanelTpl.stache'

/**
 * @class CpcFromInfoPanel
 * Afficher les infos d'un cpcFrom
 */
let CpcFromInfoPanel = InfoPanel.extend({
  template: CpcFromInfoPanelTplStache,
  i18nPrefix: ['uda.cpcFrom.', 'thm.ui.common.cpcFrom.CpcFromInfoPanel.'],
  id: 'cpcFromInfoPanel',
  entityId: 'cpcFrom',
})

export default CpcFromInfoPanel
